import { Link } from 'react-router-dom';
import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
function ClientsSection() {
    const responsiveOptions = {
        0: {
            items: 1, // Number of items to display on screens smaller than 600px
            dots: false, // Display dots pagination
        },
        600: {
            items: 3, // Number of items to display on screens with a width of 600px or more
        },
        1000: {
            items: 5, // Number of items to display on screens with a width of 1000px or more
        },
    };
    return (
        <section className="clientSection padd-30">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="commanHead">
                            <h2> Our Clients </h2>
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <OwlCarousel id="owl-demo" className='owl-theme' responsive={responsiveOptions} margin={10} lazyLoad={true} items={5} autoplay={3000}>
                            <div className="item">
                                <img src="../assets/images/clients/harikrupa-builders.jpg" alt="Harikrupa Builders" title="Harikrupa Builders" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/goel-ganga-developers.jpg" alt="Goel Ganga Developers" title="Goel Ganga Developers" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/Majestique-landmarks.jpg" alt="Majestique Landmarks" title="Majestique Landmarks" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/dynamic-reality-ventures.jpg" alt="Dynamic Reality Ventures" title="Dynamic Reality Ventures" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/bharucha-and-motivala.png" alt="Bharucha & Motivala Infrastructure Pvt. Ltd." title="Bharucha & Motivala Infrastructure Pvt. Ltd." />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/atrium-homes.jpg" alt="Atrium Homes" title="Atrium Homes" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/gagan-developers.png" alt="Gagan Developers" title="Gagan Developers" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/f5-realtors.png" alt="F5 Realtors" title="F5 Realtors" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/ama-properties.jpg" alt="AMA Properties" title="AMA Properties" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/vtp-reality.jpg" alt="VTP Realty" title="VTP Realty" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/atur-india.jpg" alt="Atur India" title="Atur India" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/marimagnum-construction.jpg" alt="Marimagnum Construction" title="Marimagnum Construction" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/golden-palms-infrastructure.png" alt="Golden Palm Infrastructure" title="Golden Palm Infrastructure" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/marimagnum-construction.jpg" alt="Marimagnum Construction" title="Marimagnum Construction" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/ranawat-group.png" alt="Ranawat Group" title="Ranawat Group" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/gagan-properties.jpg" alt="Gagan Properties" title="Gagan Properties" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/godrej-properties.jpg" alt="Godrej Properties" title="Godrej Properties" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/ISC-group.jpg" alt="ISC" title="ISC" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/vascon-engineers.jpg" alt="Vascon Engineers" title="Vascon Engineers" />
                            </div>
                            <div className="item">
                                <img src="../assets/images/clients/swami-samarth-engineers.jpg" alt="Shree Swami Samarth Engineers" title="Shree Swami Samarth Engineers" />
                            </div>
                        </OwlCarousel>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                        <Link to="/clients" className="popart-btn" data-form="order-form" data-btn-type="open-form">
                            <i className="fa fa-hand-point-right"></i> View All
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ClientsSection;
